module.exports = __webpack_public_path__ + "static/media/md-git-merge.71f5d12f.svg";